import React from 'react'
import ReactDOM from 'react-dom'
import MediaQuery from 'react-responsive'
import {Router,Route,IndexRoute,browserHistory} from 'react-router'
import App from './components/app'
import Container from './components/container'
import Home from './components/Home/Index'

/*手机端引入*/
import MobileApp from './components/mobile_app'
import MobileContainer from './components/mobile_container'

ReactDOM.render((
 <div>
   {/* <Router history={hashHistory}>
       <Route path='/' component={App}>

         <IndexRoute component={NewsContainer}/>
         <Route path='/news_detail/:uniquekey/:type' component={NewsDetail}></Route>
         <Route path='/user_center' component={UserCenter}></Route>
       </Route>

  </Router> */}
   <MediaQuery query='(min-device-width: 575px)'>
     <Router history={browserHistory}>
       <Route path='/' component={App}>

         <IndexRoute component={Container}/>
         {/* {/* <Route path='/news_detail/:uniquekey/:type' component={NewsDetail}></Route> */}
         <Route path='/home' component={Home}></Route>
       </Route>

     </Router>
   </MediaQuery>
   <MediaQuery query='(max-device-width: 575px)'>
     <Router history={browserHistory}>
       <Route path='/' component={MobileApp}>

         <IndexRoute component={MobileContainer}/>
         {/* <Route path='/news_detail/:uniquekey' component={MobileNewsDetail}></Route>
         <Route path='/user_center' component={MobileUserCenter}></Route> */}
       </Route>
     </Router>
   </MediaQuery>
 </div>
), document.getElementById('root'))




// WEBPACK FOOTER //
// ./src/index.js